import { DataLoaderParams } from '@/types/DataLoaderParams';
import { fetchDataForItemPage } from '@/redux/modules/itemPage/itemPage.actions';
import { getIdFromPath, getNotFoundUrl } from '@/utils/urls';

export default async ({ location, match: { params }, redirect, referrer, store: { dispatch } }: DataLoaderParams) => {
    const itemId = getIdFromPath(params.itemId);

    if (!itemId) {
        return redirect(getNotFoundUrl());
    }

    // Always use new similar items for bots
    const useNewSimilarItems = true;
    // Scout categories should always be true for SSR
    const useScoutCategories = true;

    return dispatch(
        fetchDataForItemPage({
            itemId,
            location,
            redirect,
            referrer,
            useNewSimilarItems,
            useScoutCategories,
        })
    );
};
